import React from 'react';
import Header from '../components/Header';
import OrganizerCards from '../components/OrganizerCards';
import Footer from '../components/Footer';

function OrganizersPage() {
  return (
    <>
      <Header />
      <div className="pt-16 md:pt-20">
        <OrganizerCards />
      </div>
      <Footer />
    </>
  );
}

export default OrganizersPage;
